import React from 'react';

interface BenchmarkData {
  category: string;
  yourScore: number;
  industryAverage: number;
  topPerformers: number;
}

interface BenchmarkComparisonProps {
  benchmarks: BenchmarkData[];
}

const BenchmarkComparison = ({ benchmarks }: BenchmarkComparisonProps) => {
  return (
    <div className="bg-card rounded-lg p-8 shadow-subtle border border-border">
      <h3 className="text-xl font-display font-semibold text-secondary mb-6">Industry Benchmark Comparison</h3>
      
      <div className="space-y-6">
        {benchmarks.map((benchmark, index) => (
          <div key={index} className="space-y-3">
            <h4 className="text-sm font-medium text-foreground">{benchmark.category}</h4>
            
            <div className="space-y-2">
              <div className="flex items-center gap-3">
                <span className="text-xs text-muted-foreground w-24">Your Score</span>
                <div className="flex-1 h-3 bg-muted rounded-full overflow-hidden">
                  <div
                    className="h-full bg-primary transition-all duration-500"
                    style={{ width: `${benchmark.yourScore}%` }}
                  />
                </div>
                <span className="text-xs font-semibold text-primary w-12 text-right">{benchmark.yourScore}%</span>
              </div>
              
              <div className="flex items-center gap-3">
                <span className="text-xs text-muted-foreground w-24">Industry Avg</span>
                <div className="flex-1 h-3 bg-muted rounded-full overflow-hidden">
                  <div
                    className="h-full bg-muted-foreground/40 transition-all duration-500"
                    style={{ width: `${benchmark.industryAverage}%` }}
                  />
                </div>
                <span className="text-xs font-medium text-muted-foreground w-12 text-right">{benchmark.industryAverage}%</span>
              </div>
              
              <div className="flex items-center gap-3">
                <span className="text-xs text-muted-foreground w-24">Top 10%</span>
                <div className="flex-1 h-3 bg-muted rounded-full overflow-hidden">
                  <div
                    className="h-full bg-accent transition-all duration-500"
                    style={{ width: `${benchmark.topPerformers}%` }}
                  />
                </div>
                <span className="text-xs font-semibold text-accent w-12 text-right">{benchmark.topPerformers}%</span>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-6 p-4 bg-muted/50 rounded-lg">
        <p className="text-sm text-muted-foreground">
          Benchmarks based on assessments from over 500 enterprises across Australia and New Zealand in similar industries and organizational sizes.
        </p>
      </div>
    </div>
  );
};

export default BenchmarkComparison;